import PreviewExerciserScreen from "./previewScreens/PreviewExerciserScreen";
import PreviewQuestionScreen from "./previewScreens/PreviewQuestionScreen";
import {useCallback, useEffect, useState} from "react";
import {getLocalItemAsJsonFromKey, kRefreshTokenKey, kTokenKey, setLocalItemFromKey} from "../services/LocalStorage";
import {isNonEmptyString, isNullOrUndefined} from "../services/Validator";
import {refresh_token} from "../api/authentication";
import {updateUserEmail} from "../actions/user";
import {kInternalRoutes} from "../constants/internalRoutes";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import SystemScreenLoader from "../components/loaders/SystemScreenLoader";

export default function PreviewScreen({isQuestion}) {
    // Used in index.js to preview one specific Question in both Flash and Correction views

    // PROPERTIES
    const location = useLocation()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isScreenLoading, setIsScreenLoading] = useState(true)
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    // HOOKS
    // ---- Check if an authenticated user is connected
    const checkAuthenticatedUser = useCallback(() => {
        // Define
        const redirectToAuthenticationScreen = () => {
            navigate(`${kInternalRoutes.authentication}?redirect=${encodeURIComponent(location.pathname)}`)
        }

        // Perform
        // ---- Set loader and clean error
        setIsScreenLoading(true)
        // ---- Check refreshToken presence
        const refreshToken = getLocalItemAsJsonFromKey(kRefreshTokenKey)
        if (isNullOrUndefined(refreshToken) || !isNonEmptyString(refreshToken)) {
            // Case : No refreshToken found
            redirectToAuthenticationScreen()
        } else {
            // Case : refreshToken found => refreshToken
            let data = {
                "refreshToken": refreshToken
            }
            refresh_token(data).then((res) => {
                if (!isNonEmptyString(res?.token) || !isNonEmptyString(res.refreshToken) || !isNonEmptyString(res?.user)) {
                    // Case : Response is KO => Navigate to authentication
                    redirectToAuthenticationScreen()
                } else {
                    // Case : Response is OK
                    // ---- Store tokens in local storage and user email
                    setLocalItemFromKey(kTokenKey, res.token)
                    setLocalItemFromKey(kRefreshTokenKey, res.refreshToken)
                    dispatch(updateUserEmail(res.user))
                    setIsAuthenticated(true)
                }
            }).catch(() => {
                // Navigate to authentication
                redirectToAuthenticationScreen()
            }).finally(() => {
                // Switch loader on
                setIsScreenLoading(false)
            })
        }
    }, [dispatch, location.pathname, navigate])
    useEffect(() => {
        checkAuthenticatedUser()
    }, [checkAuthenticatedUser])

    // BUILD
    if (isScreenLoading)
        return <SystemScreenLoader />
    // Ici, on monte les composants enfants **seulement si auth OK**
    if (!isAuthenticated)
        return null
    return isQuestion
        ? <PreviewQuestionScreen />
        : <PreviewExerciserScreen />
}